import api from '@/api'
import {
  FilterComparisonModes,
  FilterConditions,
  FilterContainmentModes,
  WellKnownFolderName,
} from '../types'
export default {
  //읽지않은 메일이 존재하는 폴더 리스트
  getHasUnreadMailFolder():Promise<any> {
    return api.get<any>({
      url: '/IsuMail/ISU_Folder/hasUnreadMail'
    })
  },
  
  getUnreadCount(): Promise<number> {
    return api.get<number>({
      url: '/api/ews/folder/unread',
      params: { folder: 'Inbox' },
    })
  },

  getFolderTree(parentId?: string): Promise<PagedItemList<mail.MailboxFolder>> {
    const data: mail.api.DynamicApiOptions = {
      fields: [
        { key: 'Id' },
        { key: 'ChildFolderCount' },
        { key: 'DisplayName', as: 'name' },
        { key: 'WellKnownFolderName' },
        { key: 'PR_ATTR_HIDDEN' },
        { key: 'UnreadCount' },
        { key: 'TotalCount' },
        { key: 'ParentFolderId' },
        { key: 'USER_IS_FAVORITE', as: 'isFavorite' },
      ],
      filters: [
        {
          key: 'FolderClass',
          value: 'IPF.Note',
          condition: FilterConditions.IsEqualTo,
        },
        {
          key: 'PR_ATTR_HIDDEN',
          value: 'false',
          condition: FilterConditions.IsEqualTo,
        },
      ],
      parentId: parentId || null, // 최초 로드시 기본 목록을 가져오기 위해 null 상태임
      wellKnownParentName: WellKnownFolderName.MsgFolderRoot, // parentId가 null이 아닌 경우 이 값은 무시됨. 기본 폴더 목록 가져오기 위함.
      type: 'Folder',
    }

    return api
      .post<PagedItemList<mail.MailboxFolder>>({
        url: '/api/ews/Dynamic/list',
        data: data,
      })
      .then((res) => {
        var newData = {
          ...res,
          items: res.items
            .filter((x) => {
              return x.wellKnownFolderName !== 'syncissues'
            })
            .map(
            (item) =>
              ({
                ...item,
                type: 'Folder',
                children: null,
                hasChildren: item.childFolderCount > 0,
              } as mail.MailboxFolder)
          ),
        }
        return newData
      })
  },

  getFolder(id: string): Promise<mail.MailboxFolder> {
    const data: mail.api.DynamicApiOptions = {
      fields: [
        { key: 'Id' },
        { key: 'ChildFolderCount' },
        { key: 'DisplayName', as: 'name' },
        { key: 'WellKnownFolderName' },
        { key: 'UnreadCount' },
        { key: 'ParentFolderId' },
        { key: 'USER_IS_FAVORITE', as: 'isFavorite' },
      ],
      itemId: id,
      type: 'Folder',
    }
    return api
      .post({
        url: '/api/ews/dynamic/get',
        data: data,
      })
      .then((res: any) => res.item)
  },

  getSubFolderTree(
    parentId?: string
  ): Promise<PagedItemList<mail.MailboxFolder>> {
    const data: mail.api.DynamicApiOptions = {
      fields: [
        { key: 'Id' },
        { key: 'ChildFolderCount' },
        { key: 'DisplayName', as: 'name' },
        { key: 'WellKnownFolderName' },
        { key: 'PR_ATTR_HIDDEN' },
        { key: 'UnreadCount' },
        { key: 'ParentFolderId' },
        { key: 'USER_IS_FAVORITE', as: 'isFavorite' },
      ],
      filters: [
        {
          key: 'FolderClass',
          value: 'IPF.Note',
          condition: FilterConditions.IsEqualTo,
        },
        {
          key: 'PR_ATTR_HIDDEN',
          value: 'false',
          condition: FilterConditions.IsEqualTo,
        },
      ],
      parentId: parentId || null, // 최초 로드시 기본 목록을 가져오기 위해 null 상태임
      //   wellKnownParentName: WellKnownFolderName.MsgFolderRoot, // parentId가 null이 아닌 경우 이 값은 무시됨. 기본 폴더 목록 가져오기 위함.
      type: 'Folder',
    }

    return api
      .post<PagedItemList<mail.MailboxFolder>>({
        url: '/api/ews/Dynamic/list',
        data: data,
      })
      .then((res) => {
        var newData = {
          ...res,
          items: res.items.map(
            (item) =>
              ({
                ...item,
                type: 'Folder',
                children: null,
                hasChildren: item.childFolderCount > 0,
              } as mail.MailboxFolder)
          ),
        }
        return newData
      })
  },
  /**
   * Set favorite status
   * @param options
   */
  setFavorite: function(options: mail.Favorite): Promise<boolean> {
    const data: mail.api.DynamicApiOptions = {
      fields: [{ key: 'USER_IS_FAVORITE', value: options.isFavorite }],
      id: options.id,
      type: 'Folder',
    }
    return api.post({
      url: '/api/ews/dynamic/set',
      data: data,
    })
  },
  /**
   * 하나 이상의 폴더를 대상 폴더로 이동합니다.
   * @param ids 폴더 아이디
   * @param destinationFolderId 대상 폴더 아이디
   */
  moveFolders(ids: string[], destinationFolderId: string): Promise<boolean> {
    if (!ids || ids.length === 0) {
      console.error(`ARG_NULL_ERROR: ids is NULL or empty.`)
    }
    if (!destinationFolderId) {
      console.error(`ARG_NULL_ERROR: destinationFolderId is NULL or empty.`)
    }
    return api.post<boolean>({
      url: '/api/ews/Folder/move',
      data: {
        ids,
        destinationFolderId,
      },
    })
  },
}
